import React from "react";
import { BulkArchiveButton, FormGroup, Page } from "../../../components/common";
import {useClient, useQueryState, useTable, useUserContext} from "../../../hooks";
import { Table } from "reactstrap";
import { ApplicationRow } from "./components";
import { URLs } from "./api";
import { ApplicationStatusFilter } from "../../applications/applications";
import { Link } from "react-router-dom";

export const VolunteerApplicationsList = ({ match }) => {
  const url = URLs.list;
  const [archived, setArchived] = useQueryState("archived", false);
  const { isVPSupport } = useUserContext();
  const client = useClient();
  const {
    TableSearch,
    TableContainer,
    data,
    ViewingRecords,
    Pagination,
    TableDataFetch,
    refreshData,
    selected,
    BulkDeleteButton,
    setFilters,
  } = useTable({
    url,
    match,
    client,
    filters: {
      archived,
    },
  });

  function onStatusesChange(x) {
    const checksCompleted = (x || []).find(i => i.value === 'checks_completed');
    const checksNotCompleted = (x || []).find(i => i.value === 'checks_not_completed');

    setFilters((y) => ({
      ...y,
      checks_completed__isnull: (Boolean(checksCompleted) === Boolean(checksNotCompleted)) ? undefined : (
        !checksCompleted
      ),
      form__status__in:
        (x || [])
          .filter((i) => !i.custom)
          .map((i) => i.value)
          .join(",") || undefined,
    }));
  }

  return (
    <Page title="Volunteer Applications">
      <TableSearch className="fa-min" />
      <div className="tw-flex tw-mb-3 tw-items-start tw-gap-x-2 tw-flex-wrap">
        <FormGroup label="View Archived" check>
          <input
            type="checkbox"
            className="form-check-input"
            checked={archived}
            onChange={(e) => {
              const { checked } = e.target;
              setArchived(!!checked);
              setFilters((v) => ({
                ...v,
                archived: !!checked,
              }));
            }}
          />
        </FormGroup>
        <>
          {!isVPSupport && (
            <Link to="/refer_volunteer" className="btn btn-primary">
              Refer Volunteer
            </Link>
          )}
          <BulkDeleteButton />
          <BulkArchiveButton
            baseUrl={url}
            onSubmitted={() => {
              refreshData();
            }}
            archived={archived}
            selected={selected}
          />
        </>
        <ApplicationStatusFilter
          onChange={onStatusesChange}
          includeSafeguarding={false}
          url={URLs.list + "/statuses"}
        />
      </div>
      <TableContainer>
        <Table size="sm">
          <thead>
            <tr>
              <th select />
              {isVPSupport && (
                <th sortBy="organisation__organisation_name">Organisation</th>
              )}
              <th sortBy="created">Created</th>
              <th sortBy="form__first_name">Applicant</th>
              <th>Application status</th>
              <th />
              <th>Latest note</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {data.results.map((i) => (
              <tr
                key={i.id}
                className={i.checks_completed ? "tw-bg-green-100" : ""}
              >
                <td select />
                <ApplicationRow
                  onChanged={refreshData}
                  value={i}
                  match={match}
                />
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <div className="tw-flex tw-justify-between">
        <ViewingRecords />
        <Pagination />
      </div>
      <TableDataFetch />
    </Page>
  );
};
